module.exports = __webpack_public_path__ + "static/media/pb-1.3776362c.jpg";